import { tr } from "../i18n/LanguageContext";
import React from "react";
import { Badge } from "./ui/badge";
import { Globe, Home, Blend } from "lucide-react";

const EventTypeBadge = ({ type, className = "" }) => {
  const getTypeConfig = (eventType) => {
    switch (eventType) {
      case "online":
        return {
          label: tr("Онлайн"),
          icon: <Globe className="h-3 w-3" />,
          className: "border-sky-300 text-sky-700 bg-sky-50"
        };
      case "offline":
        return {
          label: tr("Оффлайн"),
          icon: <Home className="h-3 w-3" />,
          className: "border-amber-300 text-amber-700 bg-amber-50"
        };
      case "hybrid":
        return {
          label: tr("Гибрид"),
          icon: <Blend className="h-3 w-3" />,
          className: "border-purple-300 text-purple-700 bg-gradient-to-r from-sky-50 to-amber-50"
        };
      default:
        return {
          label: tr("Неизвестно"),
          icon: null,
          className: "border-gray-300 text-gray-700 bg-gray-50"
        };
    }
  };

  const config = getTypeConfig(type);

  return (
    <Badge 
      variant="outline" 
      className={`${config.className} ${className} flex items-center gap-1 font-medium`}
    >
      {config.icon}
      {tr(config.label)}
    </Badge>
  );
};

export default EventTypeBadge;